/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Having_IssuesInputs */

const en_common_having_issues = /** @type {(inputs: Common_Having_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Having issues?`)
};

const es_common_having_issues = /** @type {(inputs: Common_Having_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes problemas?`)
};

/**
* | output |
* | --- |
* | "Having issues?" |
*
* @param {Common_Having_IssuesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_having_issues = /** @type {((inputs?: Common_Having_IssuesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Having_IssuesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_having_issues(inputs)
	return en_common_having_issues(inputs)
});